import React from "react";
import styled from "styled-components";
import { Row, Column, Text } from "../theme/index";
import crosshairs from "../../assets/crosshair.svg";
import check from "../../assets/check.svg";
import money from "../../assets/money.svg";
import phone from "../../assets/phone.jpg";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border: 1px solid #1c334f;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  justify-self: center;
  grid-area: w;
`;

// const Border = styled.div`
//   border: 0.5px solid #2b2b2b;
//   padding: 0.5em;
//   display: flex;
//   align-items: center;
//   flex-direction: column;
// `;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 40%;
  background-color: #ffaf77;
  margin: 0 auto;
`;

const Img = styled.img`
  height: 50px;
`;

const values = [
  {
    description: "Complete all courses at your own pace online.",
    img: crosshairs
  },
  {
    description: "Quality and enjoyable courses.",
    img: check
  },
  {
    description: "Modern experience, accessible from any device.",
    img: phone
  },
  {
    description: "All courses affordably priced.",
    img: money
  }
];

export default function WhyChooseUs() {
  return (
    <Wrapper>
      {/* <Border> */}
      <Text protitle>Why Choose Us?</Text>
      <Div />
      <Column margin=".75em 0 0 0">
        {values.map((key, index) => {
          return (
            <Row
              alignitems="center"
              key={index}
              justifycontent="space-around"
              margin="1em 0"
            >
              <Img src={key.img} />
              <div style={{ width: "65%" }}>
                <Text testimony2 textalign="left" color="#2b2b2b">
                  {key.description}
                </Text>
              </div>
            </Row>
          );
        })}
      </Column>
      {/* </Border> */}
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/WhyChooseUs.jsx